import React from 'react'

export default function Page404 (): React.ReactElement {
  return <div className='flex-grow-1'>Error: 404</div>
}
